module.exports = __webpack_public_path__ + "static/media/EquinixWorkBench_PartnerFAQ_v1.4.462dea2b.pdf";